import styled from "styled-components";
import { Carousel } from "react-responsive-carousel";
import dashboardNews from "../../data/dashboardNews";
import theme from "../../theme/theme";

const CarouselStyled = styled(Carousel)``;

const Wrapper = styled.div`
  width: 100%;
  color: #004576;

  .heading {
    font-size: 24px;
    margin-bottom: 10px;
    color: #004576;
  }

  .content {
    text-align: start;
    margin-bottom: 3em;
    background-color: white;
    padding: 1.5em;
    border-radius: 5px;
    font-size: 15px;
    height: 100%;
    border-bottom: 40px solid ${theme.colors.bg};

    .newsImage {
      width: 100%;
      height: 400px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;

      @media (max-width: 480px) {
        height: 200px;
      }
    }

    & p {
      text-align: justify;
      white-space: pre-line;
      color: ${theme.colors.black};
    }

    & a {
      color: ${theme.colors.primary};
    }
  }

  .carousel .control-dots .dot {
    background-color: #8f9498;
  }
`;

const ImageWrapper = styled.img`
  width: 100%;
  height: 280px;
  border-radius: 15px;
  margin: auto;
  @media (max-width: 480px) {
    width: 67.5vw;
    height: 280px;
  }

  .image {
    max-width: 100%;
    border-radius: 5%;
  }
`;

const News = ({ isAdvisorPage = false }) => {
  return (
    <Wrapper>
      {!isAdvisorPage && <div className="heading">News</div>}
      <CarouselStyled
        dynamicHeight={false}
        infiniteLoop={true}
        autoPlay={true}
        interval={7000}
        showArrows={false}
        showStatus={false}
      >
        {dashboardNews.map((news) => (
          <div key={news.title} className="content">
            <div
              className="newsImage"
              style={{
                backgroundImage: `url(${news.photo})`,
              }}
            ></div>
            <h2 className="newsHeading">{news.title}</h2>
            <p>{news.text}</p>
            <a href={news.newsLink} target="_blank" rel="noopener noreferrer">
              Read more
            </a>
          </div>
        ))}
      </CarouselStyled>
    </Wrapper>
  );
};

export default News;
